/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Terms and Conditions functionality
document.addEventListener('DOMContentLoaded', function() {
  initializeTermsAndConditions();
});

// Also initialize when cart is updated
document.addEventListener('cart:refresh', function() {
  setTimeout(initializeTermsAndConditions, 100);
});

function initializeTermsAndConditions() {
  // Handle terms and conditions checkbox validation
  const termsCheckbox = document.getElementById('terms-agreed');
  const checkoutButton = document.querySelector('.cart-recap__checkout');
  
  if (termsCheckbox && checkoutButton) {
    // Initially disable checkout button if terms are required
    checkoutButton.disabled = true;
    checkoutButton.style.opacity = '0.6';
    checkoutButton.style.cursor = 'not-allowed';
    
    // Add event listener to checkbox
    termsCheckbox.addEventListener('change', function() {
      if (this.checked) {
        checkoutButton.disabled = false;
        checkoutButton.style.opacity = '1';
        checkoutButton.style.cursor = 'pointer';
        
        // Add terms_agreed attribute to cart
        addTermsAgreedAttribute();
      } else {
        checkoutButton.disabled = true;
        checkoutButton.style.opacity = '0.6';
        checkoutButton.style.cursor = 'not-allowed';
        
        // Remove terms_agreed attribute from cart
        removeTermsAgreedAttribute();
      }
    });
    
    // Prevent form submission if terms not agreed
    const cartForm = checkoutButton.closest('form');
    if (cartForm) {
      cartForm.addEventListener('submit', function(e) {
        if (!termsCheckbox.checked) {
          e.preventDefault();
          alert('Please agree to the Terms & Conditions before proceeding to checkout.');
          termsCheckbox.focus();
        }
      });
    }
  }
}

function addTermsAgreedAttribute() {
  // Find or create the hidden input for terms_agreed attribute
  let termsInput = document.querySelector('input[name="attributes[terms_agreed]"]');
  
  if (!termsInput) {
    // Create the hidden input if it doesn't exist
    termsInput = document.createElement('input');
    termsInput.type = 'hidden';
    termsInput.name = 'attributes[terms_agreed]';
    
    // Add it to the cart form
    const cartForm = document.querySelector('.cart-recap');
    if (cartForm) {
      cartForm.appendChild(termsInput);
    }
  }
  
  // Set the value to TRUE
  termsInput.value = 'TRUE';
}

function removeTermsAgreedAttribute() {
  // Find and remove the terms_agreed attribute input
  const termsInput = document.querySelector('input[name="attributes[terms_agreed]"]');
  
  if (termsInput) {
    termsInput.remove();
  }
}

